export default {
  currency: 'US$',
  researcherMonth: '19',
  totalResearcherMonth: null,
  researcherYear: '12',
  totalResearcherYear: null,
  totalYear: '144',
  promotion: null,
  locale: 'en',
};
